import {
  OrderBuilderActions,
  RESET_BUILDER,
} from '@ordersnproducts/modules/order-builder/actions/order-builder.actions';
import {
  NextWorkingDayActionActions,
  NextWorkingDayActionTypes,
} from '../../../shared/modules/common-specification/actions/next-working-day.actions';

export interface NextWorkingDayState {
  loading: boolean;
  nextWorkingDay: Date;
  blackout?: {
    startTime?: string;
    endTime?: string;
    startDay?: string;
    endDay?: string;
  };
  cutOffTime?: string;
  timezone?: {
    links: {
      self: string;
    };
    timeZoneId: number;
    iANACode: string;
    windowsCode: string;
    timeOffset: string;
  };
}

export const initialState: NextWorkingDayState = {
  loading: false,
  nextWorkingDay: null,
  blackout: null,
};

export function reducer(
  state = initialState,
  action: NextWorkingDayActionActions | OrderBuilderActions,
): NextWorkingDayState {
  switch (action.type) {
    case RESET_BUILDER: {
      return {
        ...initialState,
      };
    }
    case NextWorkingDayActionTypes.LOAD: {
      return {
        ...state,
        loading: true,
      } as NextWorkingDayState;
    }
    case NextWorkingDayActionTypes.LOAD_COMPLETE: {
      return {
        ...state,
        loading: false,
        nextWorkingDay: action.payload.date,
        blackout: action.payload.blackout,
        cutOffTime: action.payload.timeCut,
        timezone: action.payload.timezone,
      } as NextWorkingDayState;
    }
    default: {
      return state;
    }
  }
}
